{
    "hasNotificationApproval": true,
    "hasMarketingApproval": false
}